// Global Instructions Rule Applied!
//
// Fund full-form Fee Booking tab: embeds the Fee Booking workbench with the
// fund fixed (the standalone /fee-booking route carries the fund selector).
import React from 'react'
import { Typography } from 'antd'
import { FormSection } from '../../../../../core/components/FormSection.tsx'
import FeeBookingWorkbench from '../../../../fund_transactions/components/FeeBookingWorkbench.tsx'

const { Text } = Typography

interface FeeBookingTabProps {
  fundId?: string | null
}

export default function FeeBookingTab({ fundId }: FeeBookingTabProps) {
  return (
    <div className='h-full overflow-y-auto p-3 flex flex-col gap-3'>
      <FormSection title='Fee Booking' titleColor='orange'>
        {fundId ? (
          <FeeBookingWorkbench fundId={fundId} />
        ) : (
          <Text type='secondary'>Save the fund first to book fees.</Text>
        )}
      </FormSection>
    </div>
  )
}
